import { DATE_FORMAT } from "helpers/common";
import React from "react";
import { useSelector } from "react-redux";
const Columns = ({ handleViewUser,API_IMAGE_URL }) => 
 [
  {
    dataField: "link",
    text: "Image",
    formatter: (_, row) => (
      <span className="text-capitalize">
        <img
          src={API_IMAGE_URL + row?.photos[0].link}
          alt="album"
          className="img-fluid rounded "
          style={{ width: "50px", height: "50px" }}
        />
      </span>
    ),
  },
  {
    dataField: "album",
    text: "Album Name",
    formatter: (_, row) => <span className="text-capitalize">{row.name}</span>,
  },

  {
    text: "Created At",
    dataField: "dateCreated",
    formatter: (_, row) => DATE_FORMAT(row.dateCreated),
  },

  {
    text: "Action",
    dataField: "status",
    formatter: (_, row) => (
      <>
        {
          <button
            className="fa fa-eye"
            style={{
              fontSize: "20px",
              color: "green",
              backgroundColor: "#fff",
              border: "none",
            }}
            title="View"
            onClick={() => handleViewUser(row._id)}
          ></button>
        }
      </>
    ),
  },
];
export default Columns;
